import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'

import style from './MyhouseAuthVerification.module.scss'

import BlindContent from '@Components/atoms/BlindContent'
import IconCheckOn from '@Ui/images/myhouse/IconCheckOn.svg'
import IconCheckOff from '@Ui/images/myhouse/IconCheckOff.svg'
import IconCloseTooltip from '@Root/ui/images/myhouse/IconCloseTooltip.svg'
import ArrowRightGray7x18 from '@Ui/images/myhouse/ArrowRightGray7x18.svg'
import ArrowRightBlack7x18 from '@Ui/images/myhouse/ArrowRightBlack7x18.svg'
import ArrowDown18x7 from '@Ui/images/myhouse/ArrowDown18x7.svg'
import ArrowUp18x7 from '@Ui/images/myhouse/ArrowUp18x7.svg'
import ArrowTooltip from '@Root/ui/images/myhouse/ArrowTooltip.svg'
import { MYHOUSE_REGISTER_TERMS } from '@Root/contants/myhouseRegister'
import useAuthentication from '@Hooks/myhouse/useAuthentication'
import MyhouseAuthTerms from '@Components/modules/MyhouseAuthTerms'
import { handleNclick } from '@Helpers/nclick'
import { NCLICK, NDS_PROTOCOL } from '@Root/contants/lcs'
import { lcsSend } from '@Helpers/lcs'

const cx = className.bind(style)

type Props = {
  title: string
  onAuthClick: (event: React.MouseEvent<HTMLButtonElement>, disabled: boolean) => void
}

const MyhouseAuthVerification: React.FC<Props> = ({ title, onAuthClick }: Props) => {
  //변수선언부
  const { authentication, setAgreeCollectTerms, setAuthApplyNotifyYn } = useAuthentication()
  const { agreeCollectTerms, authApplyNotifyYn } = authentication
  const [showTerms, setShowTerms] = useState<MYHOUSE_REGISTER_TERMS>()
  const [agreeJoinTerms, setAgreeJoinTerms] = useState<boolean>()
  const [joinTermsExpand, setJoinTermsExpand] = useState<boolean>()

  // TODO: 무료 화재보험 진행시 처리
  const insuranceDisabled = true
  const [isTooltip, setIsTooltip] = useState(Boolean((localStorage.getItem('myhouse:auth:owner:insurance2:close') || 'N') === 'N'))

  //함수정의부
  const handleChangeAgreeCollectTerms = (event: React.SyntheticEvent) => {
    handleNclick(NCLICK.MY_HOUSE.AUTHENTICATION.RESIDENT_TERM.COLLECT, event)

    setAgreeCollectTerms(!agreeCollectTerms)
  }
  const handleChangeAgreeAlarmTerms = (event: React.SyntheticEvent) => {
    if (title === '입주민') {
      handleNclick(NCLICK.MY_HOUSE.AUTHENTICATION.RESIDENT_TERM.PUSH, event)
    } else {
      handleNclick(NCLICK.MY_HOUSE.AUTHENTICATION.OWNER.PUSH, event)
    }
    setAuthApplyNotifyYn(authApplyNotifyYn === 'Y' ? 'N' : 'Y')
  }

  const handleChangeAgreeJoinTerms = () => {
    // TODO: 화재보험이 포함 안되면 제거되어야함.
    setAgreeJoinTerms(!agreeJoinTerms)
  }

  const handleCollectTermsPageClick = (event: React.SyntheticEvent) => {
    event.preventDefault()
    lcsSend(NDS_PROTOCOL.MY_HOUSE.AUTHENTICATION.RESIDENT_TERM_COLLECT)
    handleNclick(NCLICK.MY_HOUSE.AUTHENTICATION.RESIDENT_TERM.COLLECT_MORE, event)
    setShowTerms(MYHOUSE_REGISTER_TERMS.COLLECT)
  }

  const handleTermsCloseClick = (event: React.SyntheticEvent) => {
    event.preventDefault()
    lcsSend(NDS_PROTOCOL.MY_HOUSE.AUTHENTICATION.RESIDENT_TERM)
    setShowTerms(undefined)
  }

  const handleJoinTermsExpand = (event: React.SyntheticEvent) => {
    event.preventDefault()
    setJoinTermsExpand(!joinTermsExpand)
  }

  const handleApplyClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (title === '입주민') {
      handleNclick(NCLICK.MY_HOUSE.AUTHENTICATION.RESIDENT_TERM.NEXT, event)
    } else {
      handleNclick(NCLICK.MY_HOUSE.AUTHENTICATION.OWNER.APPLY, event)
    }
    onAuthClick(event, title === '입주민' && !agreeCollectTerms)
  }

  const handleCloseTooltip = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    setIsTooltip(false)
    localStorage.setItem('myhouse:auth:owner:insurance2:close', 'Y')
  }

  const titleType = () => {
    return title === '집주인' ? (
      <>
        <em className={cx('emphasis')}>{title} 인증</em>을 신청합니다
      </>
    ) : (
      <>
        {title} 인증을 위해
        <br /> 아래 약관에 동의해 주세요.
      </>
    )
  }

  //useEffect
  useEffect(() => {
    setAgreeCollectTerms(false)
    setAgreeJoinTerms(false)
    setJoinTermsExpand(false)
  }, [])

  if (showTerms) {
    return <MyhouseAuthTerms termsType={showTerms} onCloseClick={handleTermsCloseClick} />
  }

  return (
    <>
      <section id="content" className={cx('article')} role="main">
        <BlindContent />
        <div className={cx('inner')}>
          <h3 className={cx('title')}>{titleType()}</h3>
          {title === '집주인' && (
            <>
              <p className={cx('verification_text')}>
                우리집 주소지 등기부등본의 소유주 명과
                <br />
                네이버회원 실명정보의 일치 여부를 확인합니다.
                <br />
                인증 완료까지 영업일 기준 1~3일의 대기 시간이 소요됩니다.
              </p>

              {/* TODO: 무료 화재보험 진행시 처리 */}
              {!insuranceDisabled && (
                <>
                  <div className={cx('checkbox')}>
                    <input type="checkbox" id="termsJoin" defaultChecked={agreeJoinTerms} onClick={handleChangeAgreeJoinTerms} />
                    <label htmlFor="termsJoin" className={cx('label')}>
                      {agreeJoinTerms ? <IconCheckOn /> : <IconCheckOff />}
                      [선택] 주택화재보험 무료 가입에 동의합니다.
                    </label>
                    <button type="button" aria-label="자세히 보기" className={cx('button_detail', 'type_join')} onClick={handleJoinTermsExpand}>
                      {joinTermsExpand ? <ArrowUp18x7 /> : <ArrowDown18x7 />}
                    </button>
                    {/* TODO: 무료 화재보험 진행시 처리 */}
                    {!insuranceDisabled && isTooltip && (
                      <span className={cx('layer')}>
                        동의 항목 확인 후 체크해 주셔야{'\n'}
                        보험 혜택을 받을 수 있어요!
                        <button type="button" id={'trend_price_close_button'} className={cx('button_close')} onClick={(e) => handleCloseTooltip(e)}>
                          <IconCloseTooltip />
                          <span className="blind">닫기</span>
                        </button>
                        <ArrowTooltip />
                      </span>
                    )}
                  </div>
                  <ul className={cx('list', joinTermsExpand && 'is_expanded')}>
                    <li className={cx('item')}>
                      <a href="#" className={cx('link_agree')}>
                        ・ DB손해보험㈜ 무료화재보험 가입서비스약관
                        <ArrowRightGray7x18 />
                      </a>
                    </li>
                    <li className={cx('item')}>
                      <a href="#" className={cx('link_agree')}>
                        ・ DB손해보험㈜ 개인 신용 정보제공동의
                        <ArrowRightGray7x18 />
                      </a>
                    </li>
                    <li className={cx('item')}>
                      <a href="#" className={cx('link_agree')}>
                        ・ 프로미가정종합보험 가입을 위한 개인정보 처리 동의
                        <ArrowRightGray7x18 />
                      </a>
                    </li>
                    <li className={cx('item')}>
                      <a href="#" className={cx('link_agree')}>
                        ・ 무료보험 가입 동의
                        <ArrowRightGray7x18 />
                      </a>
                    </li>
                  </ul>
                </>
              )}
            </>
          )}
          {title === '입주민' && (
            <div className={cx('checkbox')}>
              <input type="checkbox" id="termsCollect" defaultChecked={agreeCollectTerms} onClick={handleChangeAgreeCollectTerms} />
              <label htmlFor="termsCollect" className={cx('label')}>
                {agreeCollectTerms ? <IconCheckOn /> : <IconCheckOff />}
                [필수] 개인정보 수집 및 이용 동의
              </label>
              <button type="button" aria-label="자세히 보기" className={cx('button_detail')} onClick={handleCollectTermsPageClick}>
                <ArrowRightBlack7x18 />
              </button>
            </div>
          )}
          <div className={cx('checkbox')}>
            <input type="checkbox" id="termsAlarm" defaultChecked onClick={handleChangeAgreeAlarmTerms} />
            <label htmlFor="termsAlarm" className={cx('label')}>
              {authApplyNotifyYn === 'Y' ? <IconCheckOn /> : <IconCheckOff />}
              <span className={cx('text')}>
                <span className={cx('text_title')}>인증이 완료되면 알림을 받겠습니다.</span>
                <span className={cx('text_detail')}>네이버앱 알림 및 모바일 푸시 메시지가 전송됩니다.</span>
              </span>
            </label>
          </div>
          {title === '입주민' && (
            <p className={cx('verification_text')}>
              인증 완료까지 영업일 기준 1~3일의 대기 시간이 소요될 수 있습니다. 인증에 필요한 개인정보는 인증 완료 또는 실패로부터 7일 이후 폐기합니다.
            </p>
          )}
        </div>
        <button
          type="button"
          onClick={handleApplyClick}
          className={cx(
            'button_apply',
            // 집주인의 경우 항상 type_active 클래스로 노출
            (title === '집주인' || agreeCollectTerms) && 'type_active',
          )}
        >
          {title === '집주인' ? <>{title} 인증 신청하기</> : <>다음</>}
        </button>
      </section>
    </>
  )
}

export default MyhouseAuthVerification
